var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filterShow,
                            expression: "filterShow"
                          }
                        ],
                        staticClass: "filter-container"
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { small: "", color: "primary" } },
                          [_vm._v("search")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              staticClass: "text-field-reducido",
                              attrs: {
                                label: "CI",
                                type: "text",
                                clearable: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.filtrarPersonas()
                                }
                              },
                              model: {
                                value: _vm.filter_persona.nro_doc,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter_persona, "nro_doc", $$v)
                                },
                                expression: "filter_persona.nro_doc"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              staticClass: "text-field-reducido",
                              attrs: {
                                label: "Unidad",
                                type: "text",
                                clearable: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.filtrarUnidades()
                                }
                              },
                              model: {
                                value: _vm.filter.nombre_unidad,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "nombre_unidad", $$v)
                                },
                                expression: "filter.nombre_unidad"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-filter" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeFilterSlide()
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("close")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Cerrar filtros")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-expansion-panel",
                {
                  attrs: { popout: "" },
                  model: {
                    value: _vm.panel,
                    callback: function($$v) {
                      _vm.panel = $$v
                    },
                    expression: "panel"
                  }
                },
                _vm._l(_vm.l_unidades, function(unidad) {
                  return _c(
                    "v-expansion-panel-content",
                    {
                      key: unidad.id,
                      attrs: { lazy: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "v-avatar",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          color: _vm.foto
                                            ? "#FFF"
                                            : "light-blue darken-2",
                                          size: "40"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "white--text font-weight-bold caption"
                                          },
                                          [_vm._v(_vm._s(unidad.sigla || "-"))]
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      _vm._s(unidad.nombre_unidad) +
                                        "\n            "
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0" },
                            [
                              _c("EstructuraUnidad", {
                                attrs: {
                                  id_unidad: parseInt(unidad.id),
                                  filtros_persona: _vm.filter_persona
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e6a8d1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e6a8d1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reportes_lista_personal/components/EstructuraOrganizacional.vue
// module id = null
// module chunks = 